import { BigNumber } from 'ethers'
import moment from 'moment'
import chain from '../chains.json'
import { Dispatch, SetStateAction } from 'react'

const BSC_TESTNET = 97
const BSC_MAINNET = 56
export const SUPPORTED_CHAIN_IDS = [BSC_TESTNET, BSC_MAINNET]

const setProperty = <K extends keyof T, T>(obj: T, key: K, value: T[K]) => {
  obj[key] = value
}

const STANDARD_DECIMALS_TO_SHOW = 4

export const formatWithDecimals = (
  amount: string,
  decimals: number = STANDARD_DECIMALS_TO_SHOW
): string => Number(amount).toFixed(decimals)

export const createHandler =
  <T>(entity: T, setEntity: Dispatch<SetStateAction<T>>) =>
  <K extends keyof T>(key: K) =>
  // eslint-disable-next-line
  (event: any): void => {
    const target = event?.target
    let inputValue: any

    if (target) {
      inputValue = target.type === 'checkbox' ? target.checked : target.value
    } else {
      //is datetime
      inputValue = event
    }

    const newEntity = { ...entity }
    setProperty(newEntity, key, inputValue)
    setEntity(newEntity)
  }

export const WEEKS = 604800 //seconds

export const REGEXP_IMAGES = new RegExp(
  '^https://[^\\s/$.?#].[^\\s]*.(jpg|jpeg|png|gif|JPG|JPEG|PNG|GIF)'
)

export const REGEXP_HTTPS_LINK = new RegExp(
  '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$'
)

export const ABI_ERC20 = [
  'function name() public view returns (string)',
  'function symbol() public view returns (string)',
  'function decimals() public view returns (uint8)',
  'function totalSupply() public view returns (uint256)',
  'function balanceOf(address _owner) public view returns (uint256 balance)',
  'function transfer(address _to, uint256 _value) public returns (bool success)',
  'function transferFrom(address _from, address _to, uint256 _value) public returns (bool success)',
  'function approve(address _spender, uint256 _value) public returns (bool success)',
  'function allowance(address _owner, address _spender) public view returns (uint256 remaining)'
]

export const GENERIC_ERROR = 'There was an unexpected error'
export const GENERIC_SUCCESS_MESSAGE = 'Successful operation'

export const MessagesErrorMap = {
  'PAIR INITIALISED': `Tokens pair have already listed on PancakeSwap`,
  'INVALID PARAMS': `HardCap and Token Price must be greater than 0`,
  'MIN DIVIS': `Minimum divisibility doesn't satisfy`,
  'GENERATION COMPLETE': 'LP Tokens have already generated',
  'NOT YET': 'Unlock date has not been reached yet',
  'UniswapV2Locker: unlock date not reached': 'Unlock date has not been reached yet'
}

export const errorHandler = (e: unknown): void => {
  console.error(e)
}

export const fromHexaToFormattedDate = (hex: string): string =>
  moment(BigNumber.from(hex).toNumber() * 1000).format(DISPLAY_FORMAT_DATE)
export const getMomentFromHexa = (hex: string): moment.Moment =>
  moment(BigNumber.from(hex).toNumber() * 1000)

export const DISPLAY_FORMAT_DATE = 'LLL'
export const APP_NAME = 'Decentrx'
export const COMPANY_NAME = 'Decentrx'
export const MAIN_SUPPORT = 'mail.support@decentrx.com'
export const NOT_ENOUGH_FOUND = 'Insufficient funds'

export type Status = 'primary' | 'secondary' | 'error' | 'warning' | 'success' | 'info'

export enum STATUS {
  SUCCESS = 'success'
}

export enum LOCKER_FILTER {
  ALL = 'all',
  MINE = 'mine'
}

export enum PRESALE_STATUS {
  QUED = 0,
  ACTIVE,
  SUCCESS,
  FAILED
}

export const validateErc20FailMsg = 'Fail to get '

export type VFunction = (...params) => boolean

export const getChainData = (version?: string) => {
  const chainId = process.env['REACT_APP_CHAIN_ID']
  return chain[version || process.env['REACT_APP_VERSION']][chainId]
}

export const getVersion = (): string[] => Object.keys(chain)

export const chainData = getChainData()

export const invalidUrlMessage = 'Invalid URL'

export const CONNECT_YOUR_WALLET_MESSAGE = 'Please connect your wallet'
export const CONNECT_YOUR_WALLET_TITTLE = 'Connect your wallet'

export const UNSUPORTED_NETWORK_MESSAGE = 'You are trying to connect to an unsupported network'
export const CONNECTED_TO_UNSUPPORTED_NETWORK_MESSAGE =
  'You are connected to an unsupported network'
export const CONNECTED_TO_UNSUPPORTED_NETWORK_TITTLE = 'Unsupported network'

export const EPOCH_FACTOR_CORRECTOR = 1000

export const LOG_IN_METAMASK_MESSAGE = 'Please log in to Metamask'

export const REFRESH_PRESALES_TIME = 5000

export const LOCKER_TYPE = {
  liquidity: 1,
  standard: 2,
  reflection: 3
}

export const truncateStringInTheMiddle = (
  str: string,
  strPositionStart: number,
  strPositionEnd: number
): string => {
  const minTruncatedLength = strPositionStart + strPositionEnd
  if (minTruncatedLength < str.length) {
    return `${str.substr(0, strPositionStart)}...${str.substr(
      str.length - strPositionEnd,
      str.length
    )}`
  }
  return str
}

export declare type Maybe<T> = T | null

export const SUBMIT_TEXT = 'Submit'
export const APPROVE_TEXT = 'Approve'

export const DEFAULT_DECIMALS = 18
export const PERCENTAGE_DIVISOR = 100

export const GetPercentage = (target: BigNumber, percentage: number) =>
  target.mul(percentage).div(PERCENTAGE_DIVISOR)
